import type { SettlementFlowKind, SettlementLineRow } from "@/services/adminSettlementService";

/**
 * Resolve the workflow for the current line selection.
 * When the selection spans multiple backend ``flow_kind`` values, ``flow`` is null
 * and the UI should block actions (the API rejects mixed selections too).
 */
export function resolveSelectionFlow(lines: Pick<SettlementLineRow, "flow_kind">[]): {
  flow: SettlementFlowKind | null;
  mixedSelection: boolean;
} {
  if (lines.length === 0) {
    return { flow: null, mixedSelection: false };
  }
  const flows = new Set(lines.map((line) => line.flow_kind));
  if (flows.size > 1) {
    return { flow: null, mixedSelection: true };
  }
  return { flow: [...flows][0] ?? "UPFRONT", mixedSelection: false };
}
